import { Body, Heading } from '@e2n/ui/v2';
import { useTranslation } from 'react-i18next';
import { useDatevAppForm } from '../../components/form/hooks';
import { useStandortContext } from '../../lib/StandortContext';
import { type LoginFormInput } from './LoginFormSchema';
import { LoginInputs } from './LoginInputs';
import { lohnabrechnungsart } from './constants/lohnabrechnungsart';
import { loginFormOptions } from './loginFormOptions';
import { useDatevLogin } from './hooks/useDatevLogin';

// oxlint-disable-next-line complexity
export function LoginForm() {
  const { t } = useTranslation();
  const { standort } = useStandortContext();
  const startLogin = useDatevLogin();

  const einstellungen = standort?.lohnabrechnungseinstellungen;
  const art = einstellungen?.lohnabrechnungsart;

  const defaultValues: LoginFormInput =
    art === lohnabrechnungsart.LODAS || art === lohnabrechnungsart.LOGE
      ? {
          beraternummer: einstellungen?.beraternummer ?? '',
          mandantennummer: einstellungen?.mandantennummer ?? '',
          lohnabrechnungsart: art,
        }
      : loginFormOptions.defaultValues;

  const form = useDatevAppForm({
    ...loginFormOptions,
    defaultValues,
    onSubmit: ({ value }) => startLogin(value),
  });
  return (
    <form
      onSubmit={(e) => {
        e.preventDefault();
        e.stopPropagation();
        form.handleSubmit();
      }}>
      <form.AppForm>
        <div className="flex flex-col gap-6 w-96">
          <div className="flex flex-col gap-3">
            <Heading size={'lg'}>{t('domain.datev.login.title')}</Heading>
            <Body>{t('domain.datev.login.description')}</Body>
          </div>
          <LoginInputs form={form} />
          <form.SubmitButton
            buttonText={t('domain.datev.login.form.submit.label')}
          />
        </div>
      </form.AppForm>
    </form>
  );
}
